import {Companies} from "./models.js";

function Powerup() {

    // Integer
    const stock = 0;
    const cost = null;
    const level = null;
    const rarity = null;

    // Boolean
    const unlocked = false;
    const active = false;
    const hidden = false;
    const standard = false;

    // String
    const name = null;
    const description = null;
    const effect = null;
    const selection = null;
    const storyName = null;

    // Foreign keys
    const companyId = null;

    return {
        stock,
        cost,
        level,
        rarity,
        unlocked,
        active,
        hidden,
        standard,
        name,
        description,
        effect,
        selection,
        storyName,
        companyId,
    };
}

function getPowerupCompany(powerup) {
    return Companies.find({'$loki': powerup.companyId})[0];
}

export { Powerup, getPowerupCompany }
